import { inject } from '@angular/core'
import type {
  ActivatedRouteSnapshot,
  CanActivateFn,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router'
import { Router } from '@angular/router'

import { firstValueFrom } from 'rxjs'

import { ArticlesService } from '../api/articles-service/articles.service'

export const oldArticleIdRedirectGuard: CanActivateFn = async (
  route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot
): Promise<boolean | UrlTree> => {
  const router = inject(Router)
  const articlesService = inject(ArticlesService)
  const queryParams = route.queryParams

  const oldid = parseInt(String(queryParams['oldid'] ?? ''), 10)
  if (!isNaN(oldid) && oldid > 0) {
    const articleId = await firstValueFrom(
      articlesService.getArticleIdByOldId(oldid)
    )

    if (articleId) {
      const updatedQueryParams = { ...queryParams }
      delete updatedQueryParams['oldid']

      return router.createUrlTree(['/articles', articleId], {
        queryParams: updatedQueryParams,
      })
    }
  }

  const seneid = parseInt(String(queryParams['seneid'] ?? ''), 10)
  if (!isNaN(seneid) && seneid > 0) {
    const articleId = await firstValueFrom(
      articlesService.getArticleIdBySeneId(seneid)
    )

    if (articleId) {
      const updatedQueryParams = { ...queryParams }
      delete updatedQueryParams['seneid']

      return router.createUrlTree(['/articles', articleId], {
        queryParams: updatedQueryParams,
      })
    }
  }

  return true
}
